import { useRevealOnScroll } from "@/hooks/use-reveal-on-scroll";
import { useNavigate } from "react-router-dom";
import { EMBLEM_METAL } from "@/lib/sps-content";

const UNITS = [
  {
    id: "distilling",
    brand: "SPS",
    label: "Distilling",
    image:
      "https://customer-assets.emergentagent.com/job_spirits-production/artifacts/5othu1hl_SPS%20DISTILLING.webp",
    desc: "Servicios de destilado de Agave con los más altos estándares de calidad.",
  },
  {
    id: "bottling",
    brand: "SPS",
    label: "Bottling",
    image:
      "https://customer-assets.emergentagent.com/job_spirits-production/artifacts/swyrmfh0_SPS%20BOTTTLING.webp",
    desc: "Servicios de embotellado para destilados y bebidas.",
  },
];

export const Services = () => {
  useRevealOnScroll();
  const navigate = useNavigate();

  const goToService = (id) => {
    navigate(`/servicios#${id}`);
  };

  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative bg-[#001825] py-16 md:py-20 lg:py-24 overflow-hidden"
    >
      {/* Background image (AGAVE_WEB_SPS_3.webp) — fills entire section */}
      <div className="absolute inset-0 z-0">
        <img
          src={EMBLEM_METAL}
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-right lg:object-center"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* LEFT — spacer (background image already shows the emblem here) */}
          <div className="hidden lg:block lg:col-span-7" />

          {/* RIGHT — title + 2 unit cards (1/3 width on desktop) */}
          <div className="lg:col-span-5">
            <div className="reveal mb-6 lg:mb-8">
              <h2
                data-testid="services-title"
                className="font-sans-modern font-light text-white text-2xl md:text-3xl lg:text-4xl leading-[1.1] tracking-tight uppercase text-center lg:text-left"
              >
                Nuestras unidades<span className="hidden md:inline"> </span><br className="md:hidden" />de negocio
              </h2>
            </div>

            <div className="flex flex-col gap-4 lg:gap-6">
              {UNITS.map((u, i) => (
                <article
                  key={u.id}
                  data-testid={`service-card-${u.id}`}
                  className="reveal group relative flex flex-col gap-3 py-5 border-t border-[#8f9194]/20 last:border-b last:border-b-[#8f9194]/20 items-center lg:items-start text-center lg:text-left"
                  style={{ transitionDelay: `${i * 120}ms` }}
                >
                  {/* SPS | LABEL lockup — image if provided, else text */}
                  {u.image ? (
                    <img
                      src={u.image}
                      alt={`${u.brand} ${u.label}`}
                      className="h-[5rem] md:h-14 w-auto object-contain object-center lg:object-left mix-blend-screen"
                    />
                  ) : (
                    <div className="flex items-center gap-3">
                      <span
                        className="font-serif-display text-[#8f9194] leading-none"
                        style={{ fontSize: "clamp(2rem, 3.5vw, 3rem)" }}
                      >
                        {u.brand}
                      </span>
                      <span className="h-10 md:h-12 w-px bg-[#8f9194]/70" />
                      <span className="font-sans-modern uppercase text-[#d1d5db] tracking-[0.15em] text-xs">
                        {u.label}
                      </span>
                    </div>
                  )}

                  {/* Description */}
                  <p className="text-[#d1d5db] text-[1.25rem] md:text-base font-light leading-relaxed font-sans-modern">
                    {u.desc}
                  </p>

                  {/* CTA */}
                  <div>
                    <button
                      data-testid={`service-cta-${u.id}`}
                      onClick={() => goToService(u.id === "distilling" ? "distilling-hero" : "bottling-hero")}
                      className="inline-flex items-center justify-center px-7 py-3 text-[12px] md:px-6 md:py-2.5 md:text-[10px] border border-[#8f9194]/70 text-[#f8f9fa] uppercase tracking-[0.25em] font-sans-modern hover:bg-[#8f9194] hover:text-[#001825] transition-all duration-300"
                    >
                      Conocer más
                    </button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
